// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oFe81","bg":"styles_bg__HD5F3","para":"styles_para__q4Rma","winWrap":"styles_winWrap__tZ1Dd","amountWrap":"styles_amountWrap__gIOV-"};